import { render, staticRenderFns } from "./mdTable.vue?vue&type=template&id=5bb1940d&scoped=true"
import script from "./mdTable.vue?vue&type=script&lang=js"
export * from "./mdTable.vue?vue&type=script&lang=js"
import style0 from "./mdTable.vue?vue&type=style&index=0&id=5bb1940d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb1940d",
  null
  
)

export default component.exports